import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFiltersChange, currentLanguage }) => {
  const translations = {
    en: {
      readStatus: 'Read Status',
      all: 'All',
      unread: 'Unread',
      read: 'Read',
      dateRange: 'Date Range',
      from: 'From',
      to: 'To',
      priority: 'Priority',
      urgent: 'Urgent',
      high: 'High',
      normal: 'Normal',
      clearFilters: 'Clear Filters'
    },
    ko: {
      readStatus: '읽음 상태',
      all: '전체',
      unread: '읽지 않음',
      read: '읽음',
      dateRange: '날짜 범위',
      from: '시작',
      to: '종료',
      priority: '우선순위',
      urgent: '긴급',
      high: '높음',
      normal: '보통',
      clearFilters: '필터 초기화'
    }
  };

  const t = translations?.[currentLanguage];

  const handleFilterChange = (key, value) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const handleClearFilters = () => {
    onFiltersChange({
      readStatus: 'all',
      dateFrom: null,
      dateTo: null,
      priority: null
    });
  };

  return (
    <div className="mb-6 p-4 bg-card border border-border rounded-lg">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Read Status Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            {t?.readStatus}
          </label>
          <select
            value={filters?.readStatus || 'all'}
            onChange={(e) => handleFilterChange('readStatus', e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">{t?.all}</option>
            <option value="unread">{t?.unread}</option>
            <option value="read">{t?.read}</option>
          </select>
        </div>

        {/* Date From Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            {t?.from}
          </label>
          <input
            type="date"
            value={filters?.dateFrom || ''}
            onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        {/* Date To Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            {t?.to}
          </label>
          <input
            type="date"
            value={filters?.dateTo || ''}
            onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        {/* Priority Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            {t?.priority}
          </label>
          <select
            value={filters?.priority || ''}
            onChange={(e) => handleFilterChange('priority', e?.target?.value || null)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="">{t?.all}</option>
            <option value="urgent">{t?.urgent}</option>
            <option value="high">{t?.high}</option>
            <option value="normal">{t?.normal}</option>
          </select>
        </div>
      </div>
      {/* Clear Filters Button */}
      <div className="mt-4 flex justify-end">
        <button
          onClick={handleClearFilters}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="X" size={16} />
          {t?.clearFilters}
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;